import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { ColorsCSS } from '../../../theme/Colors.es.js';
import { Shadows } from '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { createUniqueCustomProperties } from '../../../utils/createUniqueCustomProperty.es.js';

const Vars = createUniqueCustomProperties("ModalMediaContent", ["padding"]);
const Styles = labelStyles("ModalMediaContent", {
  root: css`
    ${Vars.padding}: var(--zds-size-8, 10px);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: var(${Vars.padding});
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (min-width: 650px) {
      ${Vars.padding}: var(--zds-space-40, 40px);
    }

    img,
    iframe {
      object-fit: contain;
      max-width: 100%;
      max-height: 100%;
      // Use filter / drop-shadow over box-shadow to apply the
      // shadow to the actual rendered content, regardless of
      // how object-fit renders it.
      filter: drop-shadow(0px 20px 30px rgba(0, 0, 0, 0.5));
    }
  `,
  closeButton: css`
    position: fixed;
    width: var(--zds-size-40, 40px);
    height: var(--zds-size-40, 40px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    background: ${ColorsCSS.neutral200};
    box-shadow: var(--zds-shadow-surface, ${Shadows.elevation5});
    border-radius: 100px;
    top: max(var(${Vars.padding}) / 2, var(--zds-space-12, 10px));
    right: max(var(${Vars.padding}) / 2, var(--zds-space-12, 10px));
  `
});
const ModalMediaContent = (props) => {
  return jsx(
    "div",
    { css: Styles.root, "data-zds": true },
    props.children,
    props.closeButton && jsx("div", { css: Styles.closeButton, "data-zds": true }, props.closeButton)
  );
};

export { ModalMediaContent };
//# sourceMappingURL=ModalMediaContent.es.js.map
